export const setCallSessionInf = (sessionData) => (dispatch) => {
    dispatch({
        type: 'CALL-INFO/SET_CALL_SESSION_INFO',
        payload: sessionData,
    });
};
export const setRoomInf = (roomData) => (dispatch) => {
    dispatch({ type: 'CALL-INFO/SET_ROOM_INFO', payload: roomData });
};
export const setIsGroupCallInf = (isInGroupCall) => (dispatch) => {
    dispatch({
        type: 'CALL-INFO/SET_IS_IN_GROUP_CALL',
        payload: isInGroupCall,
    });
};
